import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal';
import './config/validate';
import './globals';

import SignUpModal from '@/components/SignUpModal';
import SignUpForm from "./components/SignUpForm";
import "./plugins/customScroll";

Vue.component("sign-up-form", SignUpForm);
Vue.component("sign-up-modal", SignUpModal);
Vue.use(VModal);

Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')